import * as ee from "react";
import Gr, { forwardRef as Hr, useContext as Nt, useState as ir, useCallback as xe, useMemo as kt, Fragment as It } from "react";
import { times as Dt, divide as Mt } from "number-precision";
import { StarFillIcon as Ft, LikeFillIcon as jt } from "@illa-design/icon";
import { Trigger as Vt } from "@illa-design/trigger";
import { globalColor as $e, illaPrefix as Ae, applyBoxStyle as Lt, deleteCssProps as Yt } from "@illa-design/theme";
import { keyframes as Wt, css as ne } from "@emotion/react";
var cr = { exports: {} }, Te = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var kr;
function zt() {
  if (kr)
    return Te;
  kr = 1;
  var e = Gr, r = Symbol.for("react.element"), n = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(u, p, h) {
    var d, m = {}, x = null, S = null;
    h !== void 0 && (x = "" + h), p.key !== void 0 && (x = "" + p.key), p.ref !== void 0 && (S = p.ref);
    for (d in p)
      a.call(p, d) && !i.hasOwnProperty(d) && (m[d] = p[d]);
    if (u && u.defaultProps)
      for (d in p = u.defaultProps, p)
        m[d] === void 0 && (m[d] = p[d]);
    return { $$typeof: r, type: u, key: x, ref: S, props: m, _owner: o.current };
  }
  return Te.Fragment = n, Te.jsx = l, Te.jsxs = l, Te;
}
var Oe = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ir;
function Ut() {
  return Ir || (Ir = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Gr, r = Symbol.for("react.element"), n = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), u = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), h = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), m = Symbol.for("react.memo"), x = Symbol.for("react.lazy"), S = Symbol.for("react.offscreen"), N = Symbol.iterator, b = "@@iterator";
    function F(t) {
      if (t === null || typeof t != "object")
        return null;
      var s = N && t[N] || t[b];
      return typeof s == "function" ? s : null;
    }
    var E = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var s = arguments.length, f = new Array(s > 1 ? s - 1 : 0), y = 1; y < s; y++)
          f[y - 1] = arguments[y];
        w("error", t, f);
      }
    }
    function w(t, s, f) {
      {
        var y = E.ReactDebugCurrentFrame, T = y.getStackAddendum();
        T !== "" && (s += "%s", f = f.concat([T]));
        var D = f.map(function(R) {
          return String(R);
        });
        D.unshift("Warning: " + s), Function.prototype.apply.call(console[t], console, D);
      }
    }
    var I = !1, c = !1, j = !1, C = !1, ae = !1, re;
    re = Symbol.for("react.module.reference");
    function se(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === a || t === i || ae || t === o || t === h || t === d || C || t === S || I || c || j || typeof t == "object" && t !== null && (t.$$typeof === x || t.$$typeof === m || t.$$typeof === l || t.$$typeof === u || t.$$typeof === p || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === re || t.getModuleId !== void 0));
    }
    function Ee(t, s, f) {
      var y = t.displayName;
      if (y)
        return y;
      var T = s.displayName || s.name || "";
      return T !== "" ? f + "(" + T + ")" : f;
    }
    function k(t) {
      return t.displayName || "Context";
    }
    function M(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case a:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case h:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            var s = t;
            return k(s) + ".Consumer";
          case l:
            var f = t;
            return k(f._context) + ".Provider";
          case p:
            return Ee(t, t.render, "ForwardRef");
          case m:
            var y = t.displayName || null;
            return y !== null ? y : M(t.type) || "Memo";
          case x: {
            var T = t, D = T._payload, R = T._init;
            try {
              return M(R(D));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var L = Object.assign, X = 0, ce, te, ue, ge, be, Me, Fe;
    function je() {
    }
    je.__reactDisabledLog = !0;
    function Xe() {
      {
        if (X === 0) {
          ce = console.log, te = console.info, ue = console.warn, ge = console.error, be = console.group, Me = console.groupCollapsed, Fe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: je,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        X++;
      }
    }
    function Qe() {
      {
        if (X--, X === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: L({}, t, {
              value: ce
            }),
            info: L({}, t, {
              value: te
            }),
            warn: L({}, t, {
              value: ue
            }),
            error: L({}, t, {
              value: ge
            }),
            group: L({}, t, {
              value: be
            }),
            groupCollapsed: L({}, t, {
              value: Me
            }),
            groupEnd: L({}, t, {
              value: Fe
            })
          });
        }
        X < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var _e = E.ReactCurrentDispatcher, Re;
    function fe(t, s, f) {
      {
        if (Re === void 0)
          try {
            throw Error();
          } catch (T) {
            var y = T.stack.trim().match(/\n( *(at )?)/);
            Re = y && y[1] || "";
          }
        return `
` + Re + t;
      }
    }
    var Se = !1, le;
    {
      var er = typeof WeakMap == "function" ? WeakMap : Map;
      le = new er();
    }
    function v(t, s) {
      if (!t || Se)
        return "";
      {
        var f = le.get(t);
        if (f !== void 0)
          return f;
      }
      var y;
      Se = !0;
      var T = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var D;
      D = _e.current, _e.current = null, Xe();
      try {
        if (s) {
          var R = function() {
            throw Error();
          };
          if (Object.defineProperty(R.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(R, []);
            } catch (Q) {
              y = Q;
            }
            Reflect.construct(t, [], R);
          } else {
            try {
              R.call();
            } catch (Q) {
              y = Q;
            }
            t.call(R.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Q) {
            y = Q;
          }
          t();
        }
      } catch (Q) {
        if (Q && y && typeof Q.stack == "string") {
          for (var _ = Q.stack.split(`
`), q = y.stack.split(`
`), V = _.length - 1, Y = q.length - 1; V >= 1 && Y >= 0 && _[V] !== q[Y]; )
            Y--;
          for (; V >= 1 && Y >= 0; V--, Y--)
            if (_[V] !== q[Y]) {
              if (V !== 1 || Y !== 1)
                do
                  if (V--, Y--, Y < 0 || _[V] !== q[Y]) {
                    var H = `
` + _[V].replace(" at new ", " at ");
                    return t.displayName && H.includes("<anonymous>") && (H = H.replace("<anonymous>", t.displayName)), typeof t == "function" && le.set(t, H), H;
                  }
                while (V >= 1 && Y >= 0);
              break;
            }
        }
      } finally {
        Se = !1, _e.current = D, Qe(), Error.prepareStackTrace = T;
      }
      var ve = t ? t.displayName || t.name : "", Nr = ve ? fe(ve) : "";
      return typeof t == "function" && le.set(t, Nr), Nr;
    }
    function we(t, s, f) {
      return v(t, !1);
    }
    function de(t) {
      var s = t.prototype;
      return !!(s && s.isReactComponent);
    }
    function oe(t, s, f) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return v(t, de(t));
      if (typeof t == "string")
        return fe(t);
      switch (t) {
        case h:
          return fe("Suspense");
        case d:
          return fe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case p:
            return we(t.render);
          case m:
            return oe(t.type, s, f);
          case x: {
            var y = t, T = y._payload, D = y._init;
            try {
              return oe(D(T), s, f);
            } catch {
            }
          }
        }
      return "";
    }
    var Ve = Object.prototype.hasOwnProperty, br = {}, _r = E.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var s = t._owner, f = oe(t.type, t._source, s ? s.type : null);
        _r.setExtraStackFrame(f);
      } else
        _r.setExtraStackFrame(null);
    }
    function dt(t, s, f, y, T) {
      {
        var D = Function.call.bind(Ve);
        for (var R in t)
          if (D(t, R)) {
            var _ = void 0;
            try {
              if (typeof t[R] != "function") {
                var q = Error((y || "React class") + ": " + f + " type `" + R + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[R] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw q.name = "Invariant Violation", q;
              }
              _ = t[R](s, R, y, f, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              _ = V;
            }
            _ && !(_ instanceof Error) && (Le(T), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", f, R, typeof _), Le(null)), _ instanceof Error && !(_.message in br) && (br[_.message] = !0, Le(T), g("Failed %s type: %s", f, _.message), Le(null));
          }
      }
    }
    var pt = Array.isArray;
    function rr(t) {
      return pt(t);
    }
    function vt(t) {
      {
        var s = typeof Symbol == "function" && Symbol.toStringTag, f = s && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return f;
      }
    }
    function ht(t) {
      try {
        return Rr(t), !1;
      } catch {
        return !0;
      }
    }
    function Rr(t) {
      return "" + t;
    }
    function Sr(t) {
      if (ht(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", vt(t)), Rr(t);
    }
    var Ce = E.ReactCurrentOwner, mt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, wr, Cr, tr;
    tr = {};
    function yt(t) {
      if (Ve.call(t, "ref")) {
        var s = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function Et(t) {
      if (Ve.call(t, "key")) {
        var s = Object.getOwnPropertyDescriptor(t, "key").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function gt(t, s) {
      if (typeof t.ref == "string" && Ce.current && s && Ce.current.stateNode !== s) {
        var f = M(Ce.current.type);
        tr[f] || (g('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', M(Ce.current.type), t.ref), tr[f] = !0);
      }
    }
    function bt(t, s) {
      {
        var f = function() {
          wr || (wr = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        f.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: f,
          configurable: !0
        });
      }
    }
    function _t(t, s) {
      {
        var f = function() {
          Cr || (Cr = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        f.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: f,
          configurable: !0
        });
      }
    }
    var Rt = function(t, s, f, y, T, D, R) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: t,
        key: s,
        ref: f,
        props: R,
        // Record the component responsible for creating this element.
        _owner: D
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: T
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function St(t, s, f, y, T) {
      {
        var D, R = {}, _ = null, q = null;
        f !== void 0 && (Sr(f), _ = "" + f), Et(s) && (Sr(s.key), _ = "" + s.key), yt(s) && (q = s.ref, gt(s, T));
        for (D in s)
          Ve.call(s, D) && !mt.hasOwnProperty(D) && (R[D] = s[D]);
        if (t && t.defaultProps) {
          var V = t.defaultProps;
          for (D in V)
            R[D] === void 0 && (R[D] = V[D]);
        }
        if (_ || q) {
          var Y = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && bt(R, Y), q && _t(R, Y);
        }
        return Rt(t, _, q, T, y, Ce.current, R);
      }
    }
    var nr = E.ReactCurrentOwner, xr = E.ReactDebugCurrentFrame;
    function pe(t) {
      if (t) {
        var s = t._owner, f = oe(t.type, t._source, s ? s.type : null);
        xr.setExtraStackFrame(f);
      } else
        xr.setExtraStackFrame(null);
    }
    var ar;
    ar = !1;
    function or(t) {
      return typeof t == "object" && t !== null && t.$$typeof === r;
    }
    function Tr() {
      {
        if (nr.current) {
          var t = M(nr.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function wt(t) {
      {
        if (t !== void 0) {
          var s = t.fileName.replace(/^.*[\\\/]/, ""), f = t.lineNumber;
          return `

Check your code at ` + s + ":" + f + ".";
        }
        return "";
      }
    }
    var Or = {};
    function Ct(t) {
      {
        var s = Tr();
        if (!s) {
          var f = typeof t == "string" ? t : t.displayName || t.name;
          f && (s = `

Check the top-level render call using <` + f + ">.");
        }
        return s;
      }
    }
    function Pr(t, s) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var f = Ct(s);
        if (Or[f])
          return;
        Or[f] = !0;
        var y = "";
        t && t._owner && t._owner !== nr.current && (y = " It was passed a child from " + M(t._owner.type) + "."), pe(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', f, y), pe(null);
      }
    }
    function $r(t, s) {
      {
        if (typeof t != "object")
          return;
        if (rr(t))
          for (var f = 0; f < t.length; f++) {
            var y = t[f];
            or(y) && Pr(y, s);
          }
        else if (or(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var T = F(t);
          if (typeof T == "function" && T !== t.entries)
            for (var D = T.call(t), R; !(R = D.next()).done; )
              or(R.value) && Pr(R.value, s);
        }
      }
    }
    function xt(t) {
      {
        var s = t.type;
        if (s == null || typeof s == "string")
          return;
        var f;
        if (typeof s == "function")
          f = s.propTypes;
        else if (typeof s == "object" && (s.$$typeof === p || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        s.$$typeof === m))
          f = s.propTypes;
        else
          return;
        if (f) {
          var y = M(s);
          dt(f, t.props, "prop", y, t);
        } else if (s.PropTypes !== void 0 && !ar) {
          ar = !0;
          var T = M(s);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", T || "Unknown");
        }
        typeof s.getDefaultProps == "function" && !s.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Tt(t) {
      {
        for (var s = Object.keys(t.props), f = 0; f < s.length; f++) {
          var y = s[f];
          if (y !== "children" && y !== "key") {
            pe(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), pe(null);
            break;
          }
        }
        t.ref !== null && (pe(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), pe(null));
      }
    }
    function Ar(t, s, f, y, T, D) {
      {
        var R = se(t);
        if (!R) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var q = wt(T);
          q ? _ += q : _ += Tr();
          var V;
          t === null ? V = "null" : rr(t) ? V = "array" : t !== void 0 && t.$$typeof === r ? (V = "<" + (M(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : V = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, _);
        }
        var Y = St(t, s, f, T, D);
        if (Y == null)
          return Y;
        if (R) {
          var H = s.children;
          if (H !== void 0)
            if (y)
              if (rr(H)) {
                for (var ve = 0; ve < H.length; ve++)
                  $r(H[ve], t);
                Object.freeze && Object.freeze(H);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              $r(H, t);
        }
        return t === a ? Tt(Y) : xt(Y), Y;
      }
    }
    function Ot(t, s, f) {
      return Ar(t, s, f, !0);
    }
    function Pt(t, s, f) {
      return Ar(t, s, f, !1);
    }
    var $t = Pt, At = Ot;
    Oe.Fragment = a, Oe.jsx = $t, Oe.jsxs = At;
  }()), Oe;
}
process.env.NODE_ENV === "production" ? cr.exports = zt() : cr.exports = Ut();
var qe = cr.exports;
function qt(e) {
  if (e.sheet)
    return e.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === e)
      return document.styleSheets[r];
}
function Bt(e) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", e.key), e.nonce !== void 0 && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var Gt = /* @__PURE__ */ function() {
  function e(n) {
    var a = this;
    this._insertTag = function(o) {
      var i;
      a.tags.length === 0 ? a.insertionPoint ? i = a.insertionPoint.nextSibling : a.prepend ? i = a.container.firstChild : i = a.before : i = a.tags[a.tags.length - 1].nextSibling, a.container.insertBefore(o, i), a.tags.push(o);
    }, this.isSpeedy = n.speedy === void 0 ? process.env.NODE_ENV === "production" : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var r = e.prototype;
  return r.hydrate = function(a) {
    a.forEach(this._insertTag);
  }, r.insert = function(a) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(Bt(this));
    var o = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var i = a.charCodeAt(0) === 64 && a.charCodeAt(1) === 105;
      i && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + a + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !i;
    }
    if (this.isSpeedy) {
      var l = qt(o);
      try {
        l.insertRule(a, l.cssRules.length);
      } catch (u) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(a) && console.error('There was a problem inserting the following rule: "' + a + '"', u);
      }
    } else
      o.appendChild(document.createTextNode(a));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(a) {
      return a.parentNode && a.parentNode.removeChild(a);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), U = "-ms-", Be = "-moz-", O = "-webkit-", vr = "comm", hr = "rule", mr = "decl", Ht = "@import", Jr = "@keyframes", Jt = "@layer", Kt = Math.abs, He = String.fromCharCode, Zt = Object.assign;
function Xt(e, r) {
  return z(e, 0) ^ 45 ? (((r << 2 ^ z(e, 0)) << 2 ^ z(e, 1)) << 2 ^ z(e, 2)) << 2 ^ z(e, 3) : 0;
}
function Kr(e) {
  return e.trim();
}
function Qt(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function P(e, r, n) {
  return e.replace(r, n);
}
function ur(e, r) {
  return e.indexOf(r);
}
function z(e, r) {
  return e.charCodeAt(r) | 0;
}
function Ne(e, r, n) {
  return e.slice(r, n);
}
function K(e) {
  return e.length;
}
function yr(e) {
  return e.length;
}
function Ye(e, r) {
  return r.push(e), e;
}
function en(e, r) {
  return e.map(r).join("");
}
var Je = 1, me = 1, Zr = 0, B = 0, W = 0, ye = "";
function Ke(e, r, n, a, o, i, l) {
  return { value: e, root: r, parent: n, type: a, props: o, children: i, line: Je, column: me, length: l, return: "" };
}
function Pe(e, r) {
  return Zt(Ke("", null, null, "", null, null, 0), e, { length: -e.length }, r);
}
function rn() {
  return W;
}
function tn() {
  return W = B > 0 ? z(ye, --B) : 0, me--, W === 10 && (me = 1, Je--), W;
}
function G() {
  return W = B < Zr ? z(ye, B++) : 0, me++, W === 10 && (me = 1, Je++), W;
}
function Z() {
  return z(ye, B);
}
function We() {
  return B;
}
function De(e, r) {
  return Ne(ye, e, r);
}
function ke(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Xr(e) {
  return Je = me = 1, Zr = K(ye = e), B = 0, [];
}
function Qr(e) {
  return ye = "", e;
}
function ze(e) {
  return Kr(De(B - 1, fr(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function nn(e) {
  for (; (W = Z()) && W < 33; )
    G();
  return ke(e) > 2 || ke(W) > 3 ? "" : " ";
}
function an(e, r) {
  for (; --r && G() && !(W < 48 || W > 102 || W > 57 && W < 65 || W > 70 && W < 97); )
    ;
  return De(e, We() + (r < 6 && Z() == 32 && G() == 32));
}
function fr(e) {
  for (; G(); )
    switch (W) {
      case e:
        return B;
      case 34:
      case 39:
        e !== 34 && e !== 39 && fr(W);
        break;
      case 40:
        e === 41 && fr(e);
        break;
      case 92:
        G();
        break;
    }
  return B;
}
function on(e, r) {
  for (; G() && e + W !== 47 + 10; )
    if (e + W === 42 + 42 && Z() === 47)
      break;
  return "/*" + De(r, B - 1) + "*" + He(e === 47 ? e : G());
}
function sn(e) {
  for (; !ke(Z()); )
    G();
  return De(e, B);
}
function cn(e) {
  return Qr(Ue("", null, null, null, [""], e = Xr(e), 0, [0], e));
}
function Ue(e, r, n, a, o, i, l, u, p) {
  for (var h = 0, d = 0, m = l, x = 0, S = 0, N = 0, b = 1, F = 1, E = 1, g = 0, w = "", I = o, c = i, j = a, C = w; F; )
    switch (N = g, g = G()) {
      case 40:
        if (N != 108 && z(C, m - 1) == 58) {
          ur(C += P(ze(g), "&", "&\f"), "&\f") != -1 && (E = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        C += ze(g);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        C += nn(N);
        break;
      case 92:
        C += an(We() - 1, 7);
        continue;
      case 47:
        switch (Z()) {
          case 42:
          case 47:
            Ye(un(on(G(), We()), r, n), p);
            break;
          default:
            C += "/";
        }
        break;
      case 123 * b:
        u[h++] = K(C) * E;
      case 125 * b:
      case 59:
      case 0:
        switch (g) {
          case 0:
          case 125:
            F = 0;
          case 59 + d:
            E == -1 && (C = P(C, /\f/g, "")), S > 0 && K(C) - m && Ye(S > 32 ? Mr(C + ";", a, n, m - 1) : Mr(P(C, " ", "") + ";", a, n, m - 2), p);
            break;
          case 59:
            C += ";";
          default:
            if (Ye(j = Dr(C, r, n, h, d, o, u, w, I = [], c = [], m), i), g === 123)
              if (d === 0)
                Ue(C, r, j, j, I, i, m, u, c);
              else
                switch (x === 99 && z(C, 3) === 110 ? 100 : x) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Ue(e, j, j, a && Ye(Dr(e, j, j, 0, 0, o, u, w, o, I = [], m), c), o, c, m, u, a ? I : c);
                    break;
                  default:
                    Ue(C, j, j, j, [""], c, 0, u, c);
                }
        }
        h = d = S = 0, b = E = 1, w = C = "", m = l;
        break;
      case 58:
        m = 1 + K(C), S = N;
      default:
        if (b < 1) {
          if (g == 123)
            --b;
          else if (g == 125 && b++ == 0 && tn() == 125)
            continue;
        }
        switch (C += He(g), g * b) {
          case 38:
            E = d > 0 ? 1 : (C += "\f", -1);
            break;
          case 44:
            u[h++] = (K(C) - 1) * E, E = 1;
            break;
          case 64:
            Z() === 45 && (C += ze(G())), x = Z(), d = m = K(w = C += sn(We())), g++;
            break;
          case 45:
            N === 45 && K(C) == 2 && (b = 0);
        }
    }
  return i;
}
function Dr(e, r, n, a, o, i, l, u, p, h, d) {
  for (var m = o - 1, x = o === 0 ? i : [""], S = yr(x), N = 0, b = 0, F = 0; N < a; ++N)
    for (var E = 0, g = Ne(e, m + 1, m = Kt(b = l[N])), w = e; E < S; ++E)
      (w = Kr(b > 0 ? x[E] + " " + g : P(g, /&\f/g, x[E]))) && (p[F++] = w);
  return Ke(e, r, n, o === 0 ? hr : u, p, h, d);
}
function un(e, r, n) {
  return Ke(e, r, n, vr, He(rn()), Ne(e, 2, -2), 0);
}
function Mr(e, r, n, a) {
  return Ke(e, r, n, mr, Ne(e, 0, a), Ne(e, a + 1, -1), a);
}
function he(e, r) {
  for (var n = "", a = yr(e), o = 0; o < a; o++)
    n += r(e[o], o, e, r) || "";
  return n;
}
function fn(e, r, n, a) {
  switch (e.type) {
    case Jt:
      if (e.children.length)
        break;
    case Ht:
    case mr:
      return e.return = e.return || e.value;
    case vr:
      return "";
    case Jr:
      return e.return = e.value + "{" + he(e.children, a) + "}";
    case hr:
      e.value = e.props.join(",");
  }
  return K(n = he(e.children, a)) ? e.return = e.value + "{" + n + "}" : "";
}
function ln(e) {
  var r = yr(e);
  return function(n, a, o, i) {
    for (var l = "", u = 0; u < r; u++)
      l += e[u](n, a, o, i) || "";
    return l;
  };
}
function dn(e) {
  return function(r) {
    r.root || (r = r.return) && e(r);
  };
}
function pn(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return r[n] === void 0 && (r[n] = e(n)), r[n];
  };
}
var vn = function(r, n, a) {
  for (var o = 0, i = 0; o = i, i = Z(), o === 38 && i === 12 && (n[a] = 1), !ke(i); )
    G();
  return De(r, B);
}, hn = function(r, n) {
  var a = -1, o = 44;
  do
    switch (ke(o)) {
      case 0:
        o === 38 && Z() === 12 && (n[a] = 1), r[a] += vn(B - 1, n, a);
        break;
      case 2:
        r[a] += ze(o);
        break;
      case 4:
        if (o === 44) {
          r[++a] = Z() === 58 ? "&\f" : "", n[a] = r[a].length;
          break;
        }
      default:
        r[a] += He(o);
    }
  while (o = G());
  return r;
}, mn = function(r, n) {
  return Qr(hn(Xr(r), n));
}, Fr = /* @__PURE__ */ new WeakMap(), yn = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var n = r.value, a = r.parent, o = r.column === a.column && r.line === a.line; a.type !== "rule"; )
      if (a = a.parent, !a)
        return;
    if (!(r.props.length === 1 && n.charCodeAt(0) !== 58 && !Fr.get(a)) && !o) {
      Fr.set(r, !0);
      for (var i = [], l = mn(n, i), u = a.props, p = 0, h = 0; p < l.length; p++)
        for (var d = 0; d < u.length; d++, h++)
          r.props[h] = i[p] ? l[p].replace(/&\f/g, u[d]) : u[d] + " " + l[p];
    }
  }
}, En = function(r) {
  if (r.type === "decl") {
    var n = r.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
}, gn = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", bn = function(r) {
  return r.type === "comm" && r.children.indexOf(gn) > -1;
}, _n = function(r) {
  return function(n, a, o) {
    if (!(n.type !== "rule" || r.compat)) {
      var i = n.value.match(/(:first|:nth|:nth-last)-child/g);
      if (i) {
        for (var l = !!n.parent, u = l ? n.parent.children : (
          // global rule at the root level
          o
        ), p = u.length - 1; p >= 0; p--) {
          var h = u[p];
          if (h.line < n.line)
            break;
          if (h.column < n.column) {
            if (bn(h))
              return;
            break;
          }
        }
        i.forEach(function(d) {
          console.error('The pseudo class "' + d + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + d.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, et = function(r) {
  return r.type.charCodeAt(1) === 105 && r.type.charCodeAt(0) === 64;
}, Rn = function(r, n) {
  for (var a = r - 1; a >= 0; a--)
    if (!et(n[a]))
      return !0;
  return !1;
}, jr = function(r) {
  r.type = "", r.value = "", r.return = "", r.children = "", r.props = "";
}, Sn = function(r, n, a) {
  et(r) && (r.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), jr(r)) : Rn(n, a) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), jr(r)));
};
function rt(e, r) {
  switch (Xt(e, r)) {
    case 5103:
      return O + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return O + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return O + e + Be + e + U + e + e;
    case 6828:
    case 4268:
      return O + e + U + e + e;
    case 6165:
      return O + e + U + "flex-" + e + e;
    case 5187:
      return O + e + P(e, /(\w+).+(:[^]+)/, O + "box-$1$2" + U + "flex-$1$2") + e;
    case 5443:
      return O + e + U + "flex-item-" + P(e, /flex-|-self/, "") + e;
    case 4675:
      return O + e + U + "flex-line-pack" + P(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return O + e + U + P(e, "shrink", "negative") + e;
    case 5292:
      return O + e + U + P(e, "basis", "preferred-size") + e;
    case 6060:
      return O + "box-" + P(e, "-grow", "") + O + e + U + P(e, "grow", "positive") + e;
    case 4554:
      return O + P(e, /([^-])(transform)/g, "$1" + O + "$2") + e;
    case 6187:
      return P(P(P(e, /(zoom-|grab)/, O + "$1"), /(image-set)/, O + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return P(e, /(image-set\([^]*)/, O + "$1$`$1");
    case 4968:
      return P(P(e, /(.+:)(flex-)?(.*)/, O + "box-pack:$3" + U + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + O + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return P(e, /(.+)-inline(.+)/, O + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (K(e) - 1 - r > 6)
        switch (z(e, r + 1)) {
          case 109:
            if (z(e, r + 4) !== 45)
              break;
          case 102:
            return P(e, /(.+:)(.+)-([^]+)/, "$1" + O + "$2-$3$1" + Be + (z(e, r + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~ur(e, "stretch") ? rt(P(e, "stretch", "fill-available"), r) + e : e;
        }
      break;
    case 4949:
      if (z(e, r + 1) !== 115)
        break;
    case 6444:
      switch (z(e, K(e) - 3 - (~ur(e, "!important") && 10))) {
        case 107:
          return P(e, ":", ":" + O) + e;
        case 101:
          return P(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + O + (z(e, 14) === 45 ? "inline-" : "") + "box$3$1" + O + "$2$3$1" + U + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (z(e, r + 11)) {
        case 114:
          return O + e + U + P(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return O + e + U + P(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return O + e + U + P(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return O + e + U + e + e;
  }
  return e;
}
var wn = function(r, n, a, o) {
  if (r.length > -1 && !r.return)
    switch (r.type) {
      case mr:
        r.return = rt(r.value, r.length);
        break;
      case Jr:
        return he([Pe(r, {
          value: P(r.value, "@", "@" + O)
        })], o);
      case hr:
        if (r.length)
          return en(r.props, function(i) {
            switch (Qt(i, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return he([Pe(r, {
                  props: [P(i, /:(read-\w+)/, ":" + Be + "$1")]
                })], o);
              case "::placeholder":
                return he([Pe(r, {
                  props: [P(i, /:(plac\w+)/, ":" + O + "input-$1")]
                }), Pe(r, {
                  props: [P(i, /:(plac\w+)/, ":" + Be + "$1")]
                }), Pe(r, {
                  props: [P(i, /:(plac\w+)/, U + "input-$1")]
                })], o);
            }
            return "";
          });
    }
}, Cn = [wn], xn = function(r) {
  var n = r.key;
  if (process.env.NODE_ENV !== "production" && !n)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (n === "css") {
    var a = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(a, function(b) {
      var F = b.getAttribute("data-emotion");
      F.indexOf(" ") !== -1 && (document.head.appendChild(b), b.setAttribute("data-s", ""));
    });
  }
  var o = r.stylisPlugins || Cn;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(n))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + n + '" was passed');
  var i = {}, l, u = [];
  l = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(b) {
      for (var F = b.getAttribute("data-emotion").split(" "), E = 1; E < F.length; E++)
        i[F[E]] = !0;
      u.push(b);
    }
  );
  var p, h = [yn, En];
  process.env.NODE_ENV !== "production" && h.push(_n({
    get compat() {
      return N.compat;
    }
  }), Sn);
  {
    var d, m = [fn, process.env.NODE_ENV !== "production" ? function(b) {
      b.root || (b.return ? d.insert(b.return) : b.value && b.type !== vr && d.insert(b.value + "{}"));
    } : dn(function(b) {
      d.insert(b);
    })], x = ln(h.concat(o, m)), S = function(F) {
      return he(cn(F), x);
    };
    p = function(F, E, g, w) {
      d = g, process.env.NODE_ENV !== "production" && E.map !== void 0 && (d = {
        insert: function(c) {
          g.insert(c + E.map);
        }
      }), S(F ? F + "{" + E.styles + "}" : E.styles), w && (N.inserted[E.name] = !0);
    };
  }
  var N = {
    key: n,
    sheet: new Gt({
      key: n,
      container: l,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: i,
    registered: {},
    insert: p
  };
  return N.sheet.hydrate(u), N;
}, lr = { exports: {} }, $ = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Vr;
function Tn() {
  if (Vr)
    return $;
  Vr = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, h = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, m = e ? Symbol.for("react.suspense") : 60113, x = e ? Symbol.for("react.suspense_list") : 60120, S = e ? Symbol.for("react.memo") : 60115, N = e ? Symbol.for("react.lazy") : 60116, b = e ? Symbol.for("react.block") : 60121, F = e ? Symbol.for("react.fundamental") : 60117, E = e ? Symbol.for("react.responder") : 60118, g = e ? Symbol.for("react.scope") : 60119;
  function w(c) {
    if (typeof c == "object" && c !== null) {
      var j = c.$$typeof;
      switch (j) {
        case r:
          switch (c = c.type, c) {
            case p:
            case h:
            case a:
            case i:
            case o:
            case m:
              return c;
            default:
              switch (c = c && c.$$typeof, c) {
                case u:
                case d:
                case N:
                case S:
                case l:
                  return c;
                default:
                  return j;
              }
          }
        case n:
          return j;
      }
    }
  }
  function I(c) {
    return w(c) === h;
  }
  return $.AsyncMode = p, $.ConcurrentMode = h, $.ContextConsumer = u, $.ContextProvider = l, $.Element = r, $.ForwardRef = d, $.Fragment = a, $.Lazy = N, $.Memo = S, $.Portal = n, $.Profiler = i, $.StrictMode = o, $.Suspense = m, $.isAsyncMode = function(c) {
    return I(c) || w(c) === p;
  }, $.isConcurrentMode = I, $.isContextConsumer = function(c) {
    return w(c) === u;
  }, $.isContextProvider = function(c) {
    return w(c) === l;
  }, $.isElement = function(c) {
    return typeof c == "object" && c !== null && c.$$typeof === r;
  }, $.isForwardRef = function(c) {
    return w(c) === d;
  }, $.isFragment = function(c) {
    return w(c) === a;
  }, $.isLazy = function(c) {
    return w(c) === N;
  }, $.isMemo = function(c) {
    return w(c) === S;
  }, $.isPortal = function(c) {
    return w(c) === n;
  }, $.isProfiler = function(c) {
    return w(c) === i;
  }, $.isStrictMode = function(c) {
    return w(c) === o;
  }, $.isSuspense = function(c) {
    return w(c) === m;
  }, $.isValidElementType = function(c) {
    return typeof c == "string" || typeof c == "function" || c === a || c === h || c === i || c === o || c === m || c === x || typeof c == "object" && c !== null && (c.$$typeof === N || c.$$typeof === S || c.$$typeof === l || c.$$typeof === u || c.$$typeof === d || c.$$typeof === F || c.$$typeof === E || c.$$typeof === g || c.$$typeof === b);
  }, $.typeOf = w, $;
}
var A = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Lr;
function On() {
  return Lr || (Lr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, h = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, m = e ? Symbol.for("react.suspense") : 60113, x = e ? Symbol.for("react.suspense_list") : 60120, S = e ? Symbol.for("react.memo") : 60115, N = e ? Symbol.for("react.lazy") : 60116, b = e ? Symbol.for("react.block") : 60121, F = e ? Symbol.for("react.fundamental") : 60117, E = e ? Symbol.for("react.responder") : 60118, g = e ? Symbol.for("react.scope") : 60119;
    function w(v) {
      return typeof v == "string" || typeof v == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      v === a || v === h || v === i || v === o || v === m || v === x || typeof v == "object" && v !== null && (v.$$typeof === N || v.$$typeof === S || v.$$typeof === l || v.$$typeof === u || v.$$typeof === d || v.$$typeof === F || v.$$typeof === E || v.$$typeof === g || v.$$typeof === b);
    }
    function I(v) {
      if (typeof v == "object" && v !== null) {
        var we = v.$$typeof;
        switch (we) {
          case r:
            var de = v.type;
            switch (de) {
              case p:
              case h:
              case a:
              case i:
              case o:
              case m:
                return de;
              default:
                var oe = de && de.$$typeof;
                switch (oe) {
                  case u:
                  case d:
                  case N:
                  case S:
                  case l:
                    return oe;
                  default:
                    return we;
                }
            }
          case n:
            return we;
        }
      }
    }
    var c = p, j = h, C = u, ae = l, re = r, se = d, Ee = a, k = N, M = S, L = n, X = i, ce = o, te = m, ue = !1;
    function ge(v) {
      return ue || (ue = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), be(v) || I(v) === p;
    }
    function be(v) {
      return I(v) === h;
    }
    function Me(v) {
      return I(v) === u;
    }
    function Fe(v) {
      return I(v) === l;
    }
    function je(v) {
      return typeof v == "object" && v !== null && v.$$typeof === r;
    }
    function Xe(v) {
      return I(v) === d;
    }
    function Qe(v) {
      return I(v) === a;
    }
    function _e(v) {
      return I(v) === N;
    }
    function Re(v) {
      return I(v) === S;
    }
    function fe(v) {
      return I(v) === n;
    }
    function Se(v) {
      return I(v) === i;
    }
    function le(v) {
      return I(v) === o;
    }
    function er(v) {
      return I(v) === m;
    }
    A.AsyncMode = c, A.ConcurrentMode = j, A.ContextConsumer = C, A.ContextProvider = ae, A.Element = re, A.ForwardRef = se, A.Fragment = Ee, A.Lazy = k, A.Memo = M, A.Portal = L, A.Profiler = X, A.StrictMode = ce, A.Suspense = te, A.isAsyncMode = ge, A.isConcurrentMode = be, A.isContextConsumer = Me, A.isContextProvider = Fe, A.isElement = je, A.isForwardRef = Xe, A.isFragment = Qe, A.isLazy = _e, A.isMemo = Re, A.isPortal = fe, A.isProfiler = Se, A.isStrictMode = le, A.isSuspense = er, A.isValidElementType = w, A.typeOf = I;
  }()), A;
}
process.env.NODE_ENV === "production" ? lr.exports = Tn() : lr.exports = On();
var Pn = lr.exports, tt = Pn, $n = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, An = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, nt = {};
nt[tt.ForwardRef] = $n;
nt[tt.Memo] = An;
var Nn = !0;
function kn(e, r, n) {
  var a = "";
  return n.split(" ").forEach(function(o) {
    e[o] !== void 0 ? r.push(e[o] + ";") : a += o + " ";
  }), a;
}
var at = function(r, n, a) {
  var o = r.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (a === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  Nn === !1) && r.registered[o] === void 0 && (r.registered[o] = n.styles);
}, In = function(r, n, a) {
  at(r, n, a);
  var o = r.key + "-" + n.name;
  if (r.inserted[n.name] === void 0) {
    var i = n;
    do
      r.insert(n === i ? "." + o : "", i, r.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function Dn(e) {
  for (var r = 0, n, a = 0, o = e.length; o >= 4; ++a, o -= 4)
    n = e.charCodeAt(a) & 255 | (e.charCodeAt(++a) & 255) << 8 | (e.charCodeAt(++a) & 255) << 16 | (e.charCodeAt(++a) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, r = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      r ^= (e.charCodeAt(a + 2) & 255) << 16;
    case 2:
      r ^= (e.charCodeAt(a + 1) & 255) << 8;
    case 1:
      r ^= e.charCodeAt(a) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var Mn = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Yr = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, Fn = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", jn = /[A-Z]|^ms/g, ot = /_EMO_([^_]+?)_([^]*?)_EMO_/g, Er = function(r) {
  return r.charCodeAt(1) === 45;
}, Wr = function(r) {
  return r != null && typeof r != "boolean";
}, sr = /* @__PURE__ */ pn(function(e) {
  return Er(e) ? e : e.replace(jn, "-$&").toLowerCase();
}), Ge = function(r, n) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(ot, function(a, o, i) {
          return J = {
            name: o,
            styles: i,
            next: J
          }, o;
        });
  }
  return Mn[r] !== 1 && !Er(r) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
if (process.env.NODE_ENV !== "production") {
  var Vn = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, Ln = ["normal", "none", "initial", "inherit", "unset"], Yn = Ge, Wn = /^-ms-/, zn = /-(.)/g, zr = {};
  Ge = function(r, n) {
    if (r === "content" && (typeof n != "string" || Ln.indexOf(n) === -1 && !Vn.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || n.charAt(0) !== '"' && n.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + n + "\"'`");
    var a = Yn(r, n);
    return a !== "" && !Er(r) && r.indexOf("-") !== -1 && zr[r] === void 0 && (zr[r] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + r.replace(Wn, "ms-").replace(zn, function(o, i) {
      return i.toUpperCase();
    }) + "?")), a;
  };
}
var it = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function Ie(e, r, n) {
  if (n == null)
    return "";
  if (n.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && n.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(it);
    return n;
  }
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      if (n.anim === 1)
        return J = {
          name: n.name,
          styles: n.styles,
          next: J
        }, n.name;
      if (n.styles !== void 0) {
        var a = n.next;
        if (a !== void 0)
          for (; a !== void 0; )
            J = {
              name: a.name,
              styles: a.styles,
              next: J
            }, a = a.next;
        var o = n.styles + ";";
        return process.env.NODE_ENV !== "production" && n.map !== void 0 && (o += n.map), o;
      }
      return Un(e, r, n);
    }
    case "function": {
      if (e !== void 0) {
        var i = J, l = n(e);
        return J = i, Ie(e, r, l);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var u = [], p = n.replace(ot, function(d, m, x) {
          var S = "animation" + u.length;
          return u.push("const " + S + " = keyframes`" + x.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + S + "}";
        });
        u.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(u, ["`" + p + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + p + "`"));
      }
      break;
  }
  if (r == null)
    return n;
  var h = r[n];
  return h !== void 0 ? h : n;
}
function Un(e, r, n) {
  var a = "";
  if (Array.isArray(n))
    for (var o = 0; o < n.length; o++)
      a += Ie(e, r, n[o]) + ";";
  else
    for (var i in n) {
      var l = n[i];
      if (typeof l != "object")
        r != null && r[l] !== void 0 ? a += i + "{" + r[l] + "}" : Wr(l) && (a += sr(i) + ":" + Ge(i, l) + ";");
      else {
        if (i === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(it);
        if (Array.isArray(l) && typeof l[0] == "string" && (r == null || r[l[0]] === void 0))
          for (var u = 0; u < l.length; u++)
            Wr(l[u]) && (a += sr(i) + ":" + Ge(i, l[u]) + ";");
        else {
          var p = Ie(e, r, l);
          switch (i) {
            case "animation":
            case "animationName": {
              a += sr(i) + ":" + p + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && i === "undefined" && console.error(Fn), a += i + "{" + p + "}";
          }
        }
      }
    }
  return a;
}
var Ur = /label:\s*([^\s;\n{]+)\s*(;|$)/g, st;
process.env.NODE_ENV !== "production" && (st = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var J, qr = function(r, n, a) {
  if (r.length === 1 && typeof r[0] == "object" && r[0] !== null && r[0].styles !== void 0)
    return r[0];
  var o = !0, i = "";
  J = void 0;
  var l = r[0];
  l == null || l.raw === void 0 ? (o = !1, i += Ie(a, n, l)) : (process.env.NODE_ENV !== "production" && l[0] === void 0 && console.error(Yr), i += l[0]);
  for (var u = 1; u < r.length; u++)
    i += Ie(a, n, r[u]), o && (process.env.NODE_ENV !== "production" && l[u] === void 0 && console.error(Yr), i += l[u]);
  var p;
  process.env.NODE_ENV !== "production" && (i = i.replace(st, function(x) {
    return p = x, "";
  })), Ur.lastIndex = 0;
  for (var h = "", d; (d = Ur.exec(i)) !== null; )
    h += "-" + // $FlowFixMe we know it's not null
    d[1];
  var m = Dn(i) + h;
  return process.env.NODE_ENV !== "production" ? {
    name: m,
    styles: i,
    map: p,
    next: J,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: m,
    styles: i,
    next: J
  };
}, qn = function(r) {
  return r();
}, Bn = ee["useInsertionEffect"] ? ee["useInsertionEffect"] : !1, Gn = Bn || qn, Ze = {}.hasOwnProperty, gr = /* @__PURE__ */ ee.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ xn({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (gr.displayName = "EmotionCacheContext");
gr.Provider;
var Hn = function(r) {
  return /* @__PURE__ */ Hr(function(n, a) {
    var o = Nt(gr);
    return r(n, o, a);
  });
}, ct = /* @__PURE__ */ ee.createContext({});
process.env.NODE_ENV !== "production" && (ct.displayName = "EmotionThemeContext");
var Br = function(r) {
  var n = r.split(".");
  return n[n.length - 1];
}, Jn = function(r) {
  var n = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(r);
  if (n || (n = /^([A-Za-z0-9$.]+)@/.exec(r), n))
    return Br(n[1]);
}, Kn = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]), Zn = function(r) {
  return r.replace(/\$/g, "-");
}, Xn = function(r) {
  if (r)
    for (var n = r.split(`
`), a = 0; a < n.length; a++) {
      var o = Jn(n[a]);
      if (o) {
        if (Kn.has(o))
          break;
        if (/^[A-Z]/.test(o))
          return Zn(o);
      }
    }
}, dr = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", pr = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", ut = function(r, n) {
  if (process.env.NODE_ENV !== "production" && typeof n.css == "string" && // check if there is a css declaration
  n.css.indexOf(":") !== -1)
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + n.css + "`");
  var a = {};
  for (var o in n)
    Ze.call(n, o) && (a[o] = n[o]);
  if (a[dr] = r, process.env.NODE_ENV !== "production" && n.css && (typeof n.css != "object" || typeof n.css.name != "string" || n.css.name.indexOf("-") === -1)) {
    var i = Xn(new Error().stack);
    i && (a[pr] = i);
  }
  return a;
}, Qn = function(r) {
  var n = r.cache, a = r.serialized, o = r.isStringTag;
  return at(n, a, o), Gn(function() {
    return In(n, a, o);
  }), null;
}, ft = /* @__PURE__ */ Hn(function(e, r, n) {
  var a = e.css;
  typeof a == "string" && r.registered[a] !== void 0 && (a = r.registered[a]);
  var o = e[dr], i = [a], l = "";
  typeof e.className == "string" ? l = kn(r.registered, i, e.className) : e.className != null && (l = e.className + " ");
  var u = qr(i, void 0, ee.useContext(ct));
  if (process.env.NODE_ENV !== "production" && u.name.indexOf("-") === -1) {
    var p = e[pr];
    p && (u = qr([u, "label:" + p + ";"]));
  }
  l += r.key + "-" + u.name;
  var h = {};
  for (var d in e)
    Ze.call(e, d) && d !== "css" && d !== dr && (process.env.NODE_ENV === "production" || d !== pr) && (h[d] = e[d]);
  return h.ref = n, h.className = l, /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement(Qn, {
    cache: r,
    serialized: u,
    isStringTag: typeof o == "string"
  }), /* @__PURE__ */ ee.createElement(o, h));
});
process.env.NODE_ENV !== "production" && (ft.displayName = "EmotionCssPropInternal");
var lt = ft;
function ie(e, r, n) {
  return Ze.call(r, "css") ? qe.jsx(lt, ut(e, r), n) : qe.jsx(e, r, n);
}
function ea(e, r, n) {
  return Ze.call(r, "css") ? qe.jsxs(lt, ut(e, r), n) : qe.jsxs(e, r, n);
}
const ra = Wt`
  0% {
    transform: scale(1);
  }

  57%{
    transform: scale(1.33);
  }
  
  100% {
    transform: scale(1);
  }
`;
function ta(e) {
  const r = e ? ne`
        cursor: not-allowed;
      ` : ne``;
  return ne`
    display: inline-block;
    user-select: none;
    ${r}
  `;
}
const na = ne`
  display: flex;
  align-items: center;
  font-size: 24px;
  min-height: 32px;
  flex-wrap: wrap;
  gap: 7px;
`;
function aa(e, r, n) {
  const a = e || r ? "" : "cursor: pointer", o = n ? ne`
        animation: ${ra} 0.35s ease-in-out;
      ` : "";
  return ne`
    position: relative;
    transition: transform 0.15s ease-in-out;
    color: ${$e(`--${Ae}-grayBlue-08`)};
    ${a};
    ${o};
    &:hover {
      transform: ${r ? "" : "scale(1.33)"};
    }
  `;
}
function oa(e, r) {
  const n = r ? `${$e(`--${Ae}-yellow-04`)}` : `${$e(`--${Ae}-red-03`)}`;
  return ne`
    position: absolute;
    top: 0;
    left: 0;
    width: 50%;
    white-space: nowrap;
    overflow: hidden;
    transition: inherit;
    color: ${e ? `${n}` : ""};
    opacity: ${e ? 1 : 0};
    > svg {
      float: left;
    }
  `;
}
function ia(e, r) {
  const n = r ? `${$e(`--${Ae}-yellow-04`)}` : `${$e(`--${Ae}-red-03`)}`;
  return ne`
    transition: inherit;
    color: ${e ? `${n}` : ""};
    > svg {
      float: left;
    }
  `;
}
const sa = Hr((e, r) => {
  const { defaultValue: n, character: a = ie(Ft, {}), count: o = 5, value: i, tooltips: l, allowHalf: u, allowClear: p, disabled: h, readonly: d, heart: m, onChange: x, onHoverChange: S, ...N } = e, [b, F] = ir(n || i || 0), [E, g] = ir(0), [w, I] = ir(), c = i !== void 0 ? i : b, j = xe(() => {
    E && (g(0), S && S(0));
  }, [E, S]), C = xe((k, M) => {
    const L = M && u ? k + 0.5 : k + 1;
    L !== E && (g(L), S && S(L));
  }, [u, E, S]), ae = xe((k, M) => {
    const L = M && u ? k + 0.5 : k + 1;
    I(!0), L !== c ? (F(L), x && x(L)) : p && (F(0), x && x(0), j());
  }, [p, u, c, x, j]), re = xe((k) => {
    let M = typeof a == "function" ? a(k) : a;
    return m && (M = ie(jt, {})), M;
  }, [a, m]), se = xe((k) => {
    const M = u ? Dt(+Mt(c || 0, 0.5).toFixed(0), 0.5) : Math.round(c), L = E || M, X = d || h ? {} : {
      onMouseEnter: () => {
        C(k, !0);
      },
      onClick: () => {
        ae(k, !0);
      }
    }, ce = d || h ? {} : {
      onMouseEnter: () => {
        C(k, !1);
      },
      onClick: () => {
        ae(k, !1);
      }
    }, te = l && l[k];
    return ie(te ? Vt : It, { ...te ? { content: te } : {}, children: ea("div", { css: aa(h ?? !1, d ?? !1, w && k + 1 < c), style: w ? { animationDelay: `${50 * k}ms` } : {}, onAnimationEnd: () => {
      w && k + 1 >= c - 1 && I(!1);
    }, children: [ie("div", { css: oa(u && k + 0.5 === L, !m), ...X, children: re(k) }), ie("div", { css: ia(k + 1 <= L, !m), ...ce, children: re(k) })] }) }, k);
  }, [
    u,
    w,
    h,
    m,
    E,
    c,
    ae,
    C,
    d,
    l,
    re
  ]), Ee = kt(() => {
    const k = [];
    for (let M = 0; M < o; M++)
      k.push(se(M));
    return k;
  }, [o, se]);
  return ie("div", { ref: r, css: [ta(h ?? !1), Lt(e)], ...Yt(N), onMouseLeave: j, children: ie("div", { css: na, children: Ee }) });
});
sa.displayName = "Rate";
export {
  sa as Rate
};
//# sourceMappingURL=index.js.map
